
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 250 250"}},[_c('path',{staticClass:"stroke",attrs:{"d":"M111.1 171.8l27.3-94.3m11.9 16.8l51.7 30.6-51.7 30.2m-50-60.8l-51.7 30.6 51.7 30.2"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      